import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_ASSESSMENT_FAILURE,
  GET_ASSESSMENT_SUCCESS,
  GET_ASSESSMENT_REQUEST,
  GET_ASSESSMENT_LOADING,
} = therapyPlanningAction;

function* getAssessment(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_ASSESSMENT_LOADING });
    const response = yield call(therapyPlanningService.getAassessment, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_ASSESSMENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_ASSESSMENT_FAILURE, payload: error });
  }
}

function* getAssessmentSaga() {
  yield takeEvery(GET_ASSESSMENT_REQUEST, getAssessment);
}

export default getAssessmentSaga;
